<template>
  <div class="pending-verification-container">
    <div class="pending-verification-header">
      <h1 class="title-pages">Pendências de Todas as Semiologias</h1>
      <p class="subtitle-info">
        Acompanhe os formulários semiológicos que aguardam validação
      </p>
    </div>

    <div class="pending-verification-content">
      <b-overlay :show="loading" opacity="0.99" variant="white" blur="2px">
        <template #overlay>
          <div class="loading-container">
            <div class="spinner-custom"></div>
            <p class="loading-text">Carregando semiologias...</p>
          </div>
        </template>

        <!-- Estado Vazio -->
        <div v-show="data.length === 0" class="empty-state">
          <div class="empty-state-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <h3 class="empty-state-title">Tudo em dia!</h3>
          <p class="empty-state-description">
            Não existem formulários pendentes no momento
          </p>
        </div>

        <!-- Tabela com Dados -->
        <div v-show="data.length > 0" class="data-table-wrapper">
          <div class="results-count">
            <i class="fas fa-file-medical-alt"></i>
            <span
              >{{ data.length }} semiologia{{
                data.length !== 1 ? "s" : ""
              }}
              pendente{{ data.length !== 1 ? "s" : "" }}</span
            >
          </div>

          <v-data-table
            dense
            :headers="headers"
            :items="data"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            class="elevation-1 pending-table"
          >
            <template v-slot:[`item.date`]="{ item }">
              <div class="date-badge">
                <i class="far fa-calendar-alt"></i>
                <span>{{ formatDate(item.created, false) }}</span>
              </div>
            </template>

            <template v-slot:[`item.user`]="{ item }">
              <div class="user-info-card">
                <div class="user-avatar">
                  <i class="fas fa-user-nurse"></i>
                </div>
                <div class="user-details">
                  <div class="user-name">
                    <i class="fas fa-user-tag"></i>
                    <span>{{ item.user_name }}</span>
                  </div>
                  <div class="user-email">
                    <i class="far fa-envelope"></i>
                    <span>{{ item.user_email }}</span>
                  </div>
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn small @click="handleItem(item.created)" class="btn-access">
                <i class="fas fa-arrow-right"></i>
                <span>Acessar</span>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </b-overlay>

      <ErrorsMessages :errors="errors" />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import api from "../../../services/api";
import routes from "../../../routes";
import { formatDateToUs, formatDate } from "../../../lib/format";

export default {
  name: "Semiology",

  components: {
    ErrorsMessages,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      headers: [
        { text: "DATA", value: "date", sortable: false, width: "15%" },
        { text: "RESPONSÁVEL", value: "user", sortable: false, width: "60%" },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "25%",
        },
      ],
      resident_id: "",
      data: [],
      errors: [],
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    formatDateToUs,

    retrieve() {
      const { id } = routes.history.current.params;
      this.resident_id = id;
      this.verify();
    },

    async verify() {
      try {
        this.loading = true;
        let { resident_id } = this;
        let params = { resident_id };

        const response = await api.get(
          "/rest-home/resident/pending-verification/semiology",
          { params }
        );

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    handleItem(date) {
      this.$emit("pendingVerification", {
        tab: "semiology",
        nav: "semiology",
        date: formatDateToUs(date),
      });
    },
  },
};
</script>

<style scoped>
.pending-verification-container {
  padding: 1.5rem;
  background: #f8f9fa;
  min-height: calc(100vh - 200px);
}

.pending-verification-header {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e9ecef;
}

.title-pages {
  color: #2c3e50;
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.subtitle-info {
  color: #6c757d;
  font-size: 0.95rem;
  margin: 0;
}

.pending-verification-content {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem;
}

.spinner-custom {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #17a2b8;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 1rem;
  color: #6c757d;
  font-size: 0.95rem;
}

/* Estado Vazio */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
}

.empty-state-icon {
  font-size: 4rem;
  color: #28a745;
  margin-bottom: 1.5rem;
  animation: fadeInScale 0.5s ease;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.empty-state-title {
  color: #2c3e50;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.empty-state-description {
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
}

/* Tabela */
.data-table-wrapper {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.results-count {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-weight: 500;
  color: #495057;
}

.results-count i {
  color: #17a2b8;
}

/* Badge de Data */
.date-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.9rem;
}

.date-badge i {
  font-size: 1rem;
}

/* Card de Usuário */
.user-info-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
}

.user-avatar {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.user-name,
.user-email {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.user-name {
  font-weight: 600;
  color: #2c3e50;
}

.user-name i {
  color: #667eea;
  font-size: 0.85rem;
}

.user-email {
  color: #6c757d;
}

.user-email i {
  color: #adb5bd;
  font-size: 0.85rem;
}

.user-email span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Botão de Acesso */
.btn-access {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  border: none !important;
  padding: 0.5rem 1.25rem !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3) !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
}

.btn-access:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4) !important;
}

.btn-access i {
  transition: transform 0.3s ease;
}

.btn-access:hover i {
  transform: translateX(4px);
}

/* Responsividade */
@media (max-width: 992px) {
  .user-info-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .pending-verification-container {
    padding: 1rem;
  }

  .title-pages {
    font-size: 1.35rem;
  }

  .user-email span {
    max-width: 200px;
  }

  .btn-access {
    width: 100%;
    justify-content: center !important;
  }

  .empty-state {
    padding: 3rem 1rem;
  }

  .empty-state-icon {
    font-size: 3rem;
  }
}
</style>